import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LoadingComponent from "../components/loading/loading.component";
import { LayoutContainer, MainLayoutContainer } from "./__layout.style";
import Header from "../components/header/common";
import { LayoutCodes } from "../utils/enums/LayoutCodes";
import ManageTripsHeader from "../components/header/manage-trips";
import { useDispatch, useSelector } from "react-redux";
import { selectUi, setModal, setSnackbar } from "../store/slices";
import { ModalWrapper, SnackBarUI } from "@corporate-trip-planner-fe/ui-components";
import { modalRegistry } from "../components/modal/modalRegistery";
function LayoutWrapperHOC(WrappedComponent, options) {
    var layoutType = options.layoutType, backgroundImage = options.backgroundImage;
    function EnhancedLayout(props) {
        var dispatch = useDispatch();
        var modal = useSelector(selectUi.modal);
        var snackbar = useSelector(selectUi.snackbar);
        var renderHeader = function () {
            switch (layoutType) {
                case LayoutCodes.MANAGE_TRIPS:
                    return _jsx(ManageTripsHeader, { layoutType: layoutType });
                default:
                    return _jsx(Header, { layoutType: layoutType });
            }
        };
        return (_jsxs(MainLayoutContainer, { children: [renderHeader(), _jsx(LoadingComponent, {}), _jsx(SnackBarUI, { snackbar: snackbar, onClose: function () { return dispatch(setSnackbar(null)); } }), _jsx(LayoutContainer, { backgroundImage: backgroundImage, children: _jsx(WrappedComponent, __assign({}, props)) }), _jsx(ModalWrapper, { modalRegistry: modalRegistry, activeModal: modal, onClose: function () { return dispatch(setModal(null)); } })] }));
    }
    return EnhancedLayout;
}
export default LayoutWrapperHOC;
